export { AppBaseEntity } from './entity/AppBaseEntity';

